import { ElementId } from "@/helpers/enums/ElementId.ts";
import { useGTMReservedPage } from "@/helpers/gtm/useGTMReservedPage.ts";
import { useCartDrawerState } from "@/helpers/useCartDrawerState.ts";
import { getAPIUrl } from "@/stores/ApolloClient/helpers/getAPIUrl.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";

export const ReservationFinale = () => {
  const { t } = useTranslation();
  const { resetAll, setPage, isForcedInquiry, inquiryOverride, setInquiryOverride } = useEngineStore(
    useShallow((state) => ({
      resetAll: state.resetAll,
      setPage: state.setPage,
      isForcedInquiry: state.calculatedCartData?.isForcedInquiry,
      inquiryOverride: state.inquiryOverride,
      setInquiryOverride: state.setInquiryOverride,
    })),
  );
  const { handleCloseCartDrawer } = useCartDrawerState();
  useGTMReservedPage();

  const isInquiry = isForcedInquiry || inquiryOverride;

  if (getAPIUrl().includes("materra")) {
    window.onbeforeunload = null;
    document.onvisibilitychange = () => {
      setPage(AppPage.AccommodationPicking);
      handleCloseCartDrawer();
      resetAll(true);
    };

    if (i18next.language === "hr") {
      window.location.replace("https://hotelmaterra.com/hvala-vam-na-rezervaciji/");
    } else {
      window.location.replace("https://hotelmaterra.com/en/hvala-vam-na-rezervaciji/");
    }

    return;
  }

  console.log(isInquiry);

  return (
    <div id={ElementId.ReservationFinale} className="c-reservation-thank-you">
      <div className="c-reservation-thank-you__overlay"></div>
      <div className="c-reservation-thank-you__content">
        <div className="c-reservation-thank-you__info u-text-center">
          <h3 className="u-h4 c-reservation-thank-you__info-title">
            {isInquiry ? t("finale.inquirySuccess") : t("successfulRes")}!
          </h3>
          <p className="u-p1">
            {isInquiry ? t("finale.inquiryThankYou") : t("finale.thankYou")} <br />
            <br />
          </p>
          <p className="u-p1">
            {isInquiry ? t("finale.inquiryConfirmationSent") : t("finale.confirmationSent")}
          </p>
          <div className="c-reservation-thank-you__info-cta">
            <button
              className="c-be-button"
              onClick={() => {
                // resets URL params
                window.history.replaceState({}, document.title, window.location.pathname);
                setPage(AppPage.AccommodationPicking);
                handleCloseCartDrawer();
                resetAll(true);
                setInquiryOverride(false);
              }}
            >
              <span className="c-be-button__label">{t("backToAllAcc")}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
